import React from "react";
import { Link } from "react-router-dom";
import SEOHead from "./SEOHead";

export default function NotFound() {
  return (
    <>
      <SEOHead
        title="Page Not Found"
        description="We couldn't find the page you're looking for. Return to BookaTherapy's homepage to continue exploring our services."
        canonical="https://bookatherapy.com/404"
        noindex
        nofollow
      />
      <main className="min-h-screen bg-slate-50 text-slate-900 flex flex-col items-center justify-center px-6 py-16">
        <div className="max-w-xl text-center space-y-6">
          <p className="text-sm font-semibold tracking-wide uppercase text-lime-600">
            404 error
          </p>
          <h1 className="text-4xl md:text-5xl font-bold">We can&apos;t find that page</h1>
          <p className="text-base md:text-lg text-slate-600">
            The link you followed may be broken or the page may have been removed.
            Use the navigation links below to continue exploring BookaTherapy.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4 pt-4">
            <Link
              to="/"
              className="inline-flex items-center justify-center rounded-md bg-[#252F4F] px-6 py-3 text-base font-semibold text-white shadow-lg shadow-blue-900/20 transition hover:bg-[#1b223a]"
            >
              Back to homepage
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center justify-center rounded-md border border-[#252F4F] px-6 py-3 text-base font-semibold text-[#252F4F] transition hover:bg-[#252F4F] hover:text-white"
            >
              Contact support
            </Link>
          </div>
        </div>
      </main>
    </>
  );
}


